











import Modal from '@/project/modals/Modal.vue';
import { Component, Prop } from 'vue-property-decorator';
import VideoRender from '@/project/video/ProductVideoRender.vue';
import serverContextService from '@/core/serverContext.service';
import VimeoPlayer, { Options } from '@vimeo/player';

@Component({
    components: { VideoRender }
})
export default class VideoFullscreenOverlay extends Modal {
    @Prop({ required: true })
    vimeoVideoId!: string;

    @Prop({ required: false })
    enableTextTrack!: boolean;

    video: VimeoPlayer | null = null;
    isPlaying: boolean = false;
    loadingVideo: boolean = false;
    vimeoVideoAspectRatio: number = 0;
    async mounted() {
        if (!this.$refs.videoMount) return;
        const options = {
            id: ensureId(this.vimeoVideoId),
            autoplay: true,
            loop: false,
            muted: false,
            controls: true,
            title: false,
            byline: false,
            portrait: false,
            autopause: true,
            responsive: true
        } as Options;
        // eslint-disable-next-line no-new
        this.video = new VimeoPlayer(this.$refs.videoMount as HTMLElement, options) as VimeoPlayer;
        this.video.on('ended', () => {
            this.isPlaying = false;
        });

        this.video.on('loaded', () => {
            this.loadingVideo = false;
        });

        const width = await this.video.getVideoWidth();
        const height = await this.video.getVideoHeight();
        this.vimeoVideoAspectRatio = width / height;

        // Finds text tracks in video, enables the one that matches site. Defaults to english
        if (this.enableTextTrack) {
            const vimeoTextTracks = await this.video.getTextTracks();
            const desiredTrackLanguage = serverContextService.siteInfo.languageCode || 'en';
            const trackThatMatchesLanguage = vimeoTextTracks.find(t => t.language === desiredTrackLanguage);
            if (trackThatMatchesLanguage) {
                this.video.enableTextTrack(trackThatMatchesLanguage.language);
            }
        }

        function ensureId(idOrUrl: string): number {
            const idParts = idOrUrl.split(/(\\|\/)/);
            let id = idOrUrl;
            if (idParts.length > 1) {
                id = idParts[idParts.length - 1];
            }
            return parseInt(id);
        }
    }
}
